/* eslint-disable @glovo/custom-rules/no-console */

import { getConfig } from '@/tools/config'

enum Colors {
  orange = '#F27A05',
  green = '#2ECC71',
  blue = '#3498DB',
  red = '#E74C3C',
  pink = '#FF00FF',
  magenta = '#CA1F7B',
  cyan = '#00FFFF',
  black = '#000000',
  yellow = '#FFFF00',
  purple = '#800080',
  navy = '#000080',
  grey = '#808080',
}

const getTextColor = (color: keyof typeof Colors) =>
  ['yellow', 'cyan'].includes(color) ? 'black' : 'white'

function baseConsoleLog(color: keyof typeof Colors, title: string, event: string, data?: unknown) {
  const isProduction = getConfig().env === 'prod'
  if (isProduction) {
    return
  }

  const logMessage = data ? `%c${title}%c %s %o` : `%c${title}%c %s`

  const defaultLogArgs = [
    `background-color:${Colors[color]}; color: ${getTextColor(color)}; font-weight: bold; padding: 2px 5px; border-radius: 3px;`,
    '',
    event,
  ]

  const logArgs = data ? [...defaultLogArgs, data] : [...defaultLogArgs]

  console.log(logMessage, ...logArgs)
}

export const consoleLog = Object.assign(
  /**
   * Log an event to the console with a custom tag for easier debugging
   * @param title - The title for the custom tag
   * @param event - A short description of the event being logged
   * @param data - Additional data to log alongside the message. If not provided, the log will exclude this part.
   */
  function (title: string, event: string, data?: unknown) {
    baseConsoleLog('orange', title, event, data) // Default color is orange
  },
  Object.keys(Colors).reduce(
    (methods, color) => {
      methods[color as keyof typeof Colors] = function (
        title: string,
        event: string,
        data?: unknown
      ): void {
        baseConsoleLog(color as keyof typeof Colors, title, event, data)
      }
      return methods
    },
    {} as Record<keyof typeof Colors, (title: string, event: string, data?: unknown) => void>
  )
)
